import { type SplitPageError } from "@/constants/splitPage";

export class FileSplitException extends Error {
  public constructor(
    public readonly type: SplitPageError,
    message: string,
    public readonly originalError?: unknown
  ) {
    super(message);
    this.name = "FileSplitException";
  }
}

export const isFileSplitException = (error: unknown): error is FileSplitException => {
  return error instanceof FileSplitException;
};
